import React from 'react'

import { Table } from '_zari/core'

import { IdGen } from 'utils'

const ContometroSection = ({ sectionData }) => {
  return (
    <>
      <Table
        headRows={[
          { label: 'LADO' },
          { label: 'COMBUSTIBLE' },
          { label: 'ANTERIOR' },
          { label: 'ACTUAL' },
          { label: 'DESPACHO' },
          { label: 'VENTA' },
          { label: 'DIFERENCIA' }
        ]}
        filas={sectionData || []}
        maxRowsShown={10}
        rowTemplate={row => (
          <Table.Row key={IdGen.newId()}>
            <Table.Cell>{row.lado || '--'}</Table.Cell>
            <Table.Cell>{row.combustible || '--'}</Table.Cell>
            <Table.Cell>{parseFloat(row.lecturaAnterior).toFixed(4) || '--'}</Table.Cell>
            <Table.Cell>{parseFloat(row.lecturaActual).toFixed(4) || '--'}</Table.Cell>
            <Table.Cell>{parseFloat(row.totalDespacho).toFixed(4) || '--'}</Table.Cell>
            <Table.Cell>{parseFloat(row.totalVenta).toFixed(4) || '--'}</Table.Cell>
            <Table.Cell>{parseFloat(row.diferencia).toFixed(4) || '--'}</Table.Cell>
          </Table.Row>
        )}
      />
    </>
  )
}

export default React.memo(ContometroSection)
